import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import Button from '@mui/material/Button';

import { ReadFile, SelectFile } from '@paragon/client-tools';
import { enqueueWarning } from '@paragon/notification-tools';

import { selectInsertionFiles } from '../../store/actions/insertionFilesActions';

type DispatchProps = ResolveThunks<typeof actionCreators>;

type Props = DispatchProps;

class InsertionFileUploader extends React.Component<Props> {
  private fileSelect: SelectFile | null = null;

  onFilesLoading = async (pFilesLoading: readonly Promise<ReadFile>[]) => {
    await this.props.selectInsertionFiles(await Promise.all(pFilesLoading));
  };

  click = () => {
    if (this.fileSelect) this.fileSelect.click();
  };

  render() {
    return (
      <Button sx={{ m: 1, py: 1 }} size="small" variant="outlined" id="selectFileButton" onClick={() => this.click()}>
        UPLOAD FILES
        <SelectFile
          id="selectFiles"
          hide
          onChange={this.onFilesLoading}
          multiple
          accept=".tre,.ans,.trs,.ldg,.dxf,.rvt,.prf"
          ref={(item) => {
            this.fileSelect = item;
          }}
        />
      </Button>
    );
  }
}

const actionCreators = {
  enqueueWarning,
  selectInsertionFiles,
};

export default connect(null, actionCreators)(InsertionFileUploader);
